import React, { useState, useEffect } from 'react';
import { Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import * as roleService from '../../services/role/roleService';
import StandardDrawer from '../../components/common/StandardDrawer';

const RoleEditForm = ({ visible, role, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (visible && role) {
      form.setFieldsValue({
        id: role.id,
        name: role.name,
        code: role.code,
        description: role.description
      });
    }
  }, [visible, role, form]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      // 构造API请求数据
      const roleData = {
        id: values.id,
        name: values.name,
        code: values.code,
        description: values.description || ''
      };
      
      const response = await roleService.updateRole(roleData);
      
      if (response.success) {
        message.success(t('role.updateSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('role.updateFailed'));
      }
    } catch (error) {
      console.error('Update role failed:', error);
      message.error(error.message || t('role.updateFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <StandardDrawer
      visible={visible}
      onClose={onCancel}
      onOk={handleSubmit}
      title={t('role.editTitle')}
      confirmLoading={loading}
      width={480}
      maskClosable={false}
      destroyOnClose={true}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ padding: '24px 0' }}
      >
        <Form.Item
          name="id"
          hidden
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="code"
          hidden
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="name"
          label={t('role.name')}
          rules={[
            {
              pattern: /^[^!@#$%^&*()]+$/,
              message: t('role.nameSpecialCharNotAllowed') || '名称不能包含特殊字符 !@#$%^&*()'
            }
          ]}
        >
          <Input 
            placeholder={t('role.namePlaceholder')} 
            maxLength={50}
          />
        </Form.Item>

        <Form.Item
          name="description"
          label={t('role.description')}
        >
          <Input.TextArea 
            placeholder={t('role.descriptionPlaceholder')} 
            maxLength={100} 
            rows={4}
          />
        </Form.Item>
      </Form>
    </StandardDrawer>
  );
};

export default RoleEditForm;